import { SEO } from "../components/SEO";

export const Gallery = () => {
  return (
    <div className="min-h-screen pt-20 bg-navy-900">
      <SEO 
        title="Gallery | Magic C Plumbing | Plumber & Heating Engineer in London"
        description="Explore stunning transformations: outdoor luxury bathrooms, heat pump installations, underfloor heating, and smart plumbing projects across London."
        canonical="/gallery"
      />
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-navy-900 to-navy-800 text-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Transformation Gallery
            </h1>
            <p className="text-xl text-gray-300">
              Discover our expert craftsmanship transforming ordinary spaces into extraordinary luxury experiences across London
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-navy-900">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-12">
              <h2 className="text-3xl font-bold text-white mb-6">
                Our Work Speaks for Itself
              </h2>
              <p className="text-xl text-gray-300 mb-8">
                We're currently updating our gallery with stunning new projects from across London.
              </p>
              <p className="text-lg text-gray-400 mb-10">
                From luxury bathroom installations to cutting-edge heating systems, our portfolio showcases the highest standards of craftsmanship and attention to detail.
              </p>
              <div className="space-y-4">
                <a href="/contact" className="inline-block bg-sage-600 hover:bg-sage-500 text-white font-semibold px-8 py-4 rounded-lg transition-all duration-300 shadow-xl hover:shadow-sage-600/50">
                  Request a Free Consultation
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
